import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const get_proxy_by_id = (id) => {
  return api.post(`${ApiEndpointConstants.GETPROXY}`, {}, { params: { id } });
};
